// @flow

// Vendors
import React from 'react';
import classnames from 'classnames';

// types
import { InputSelectType } from '../../../types';

const InputSelect = ({
  label,
  options,
  emptyOptionLabel = 'Select one...',
  optionMapKey = 'value',
  ...props
}: InputSelectType) => (
  <>
    <label htmlFor={props.id} className="form__label">
      {label}
    </label>
    <div className="form__select">
      <select {...props}>
        <option value="">{emptyOptionLabel}</option>
        {options.map(option => (
          <option key={option[optionMapKey]} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  </>
);

export default InputSelect;
